/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2673
 */

"use strict"

var r
var i
export { r as a };
(function (e) {
  e.Ok = "ok"
  e.Exited = "exited"
  e.Crashed = "crashed"
  e.Abnormal = "abnormal"
})(r || (r = {}));
(function (e) {
  e.Ok = "ok"
  e.Errored = "errored"
  e.Crashed = "crashed"
})(i || (i = {}))
export default r
